import { render, staticRenderFns } from "./Tarif.vue?vue&type=template&id=2e26e0a0&"
import script from "./Tarif.vue?vue&type=script&lang=js&"
export * from "./Tarif.vue?vue&type=script&lang=js&"
import style0 from "./Tarif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports